import { Component, OnDestroy} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { QualityareamasterService } from 'src/app/services/qualityareamaster.service';

@Component({
  selector: 'btn-RendererQualityMasterAreas',
  template: `
      <button mat-mini-fab color="primary" (click)="onClick($event)">
      <mat-icon>edit</mat-icon>
      </button>
      <button mat-mini-fab color="warn" (click)="onClick($event)"  [disabled]="this.checkDisabled">
      <mat-icon>delete</mat-icon>
      </button>
`
})
// tslint:disable-next-line:component-class-suffix
export class BtnRendererQualityMasterAreas implements ICellRendererAngularComp, OnDestroy{
  public params: any;
  checkList: any[];
  public qualityTypeId: number;
  serviceExOnce: boolean = false;
  plantId: number;
  groupId: number;
  checkDisabled: boolean;

  constructor(private QualityareamasterService: QualityareamasterService) { }


  refresh(params: any): boolean {
      throw new Error('Method not implemented.');
  }

  agInit(params: any): void {
      this.params = params;
      this.qualityTypeId = params.node.data.qualityTypeId;
      this.plantId = params.node.data.plantId;
      this.checkDisabled = params.node.data.matchedByClist;
  }

  onClick($event: any): any {
      if (this.params.onClick instanceof Function) {
          // put anything into params u want pass into parents component
          const params = {
              event: $event,
              rowData: this.params.node.data
              // ...something
          };
          this.params.onClick(params);
      }
  }

  ngOnDestroy(): any {
      // no need to remove the button click handler
      // https://stackoverflow.com/questions/49083993/does-angular-automatically-remove-template-event-listeners
  }
}
